const PageHeader = ({
  headerText,
  additionalComponent,
}: {
  headerText: string;
  additionalComponent?: React.ReactNode;
}) => {
  // rendering page header component here
  return (
    <div className='flex flex-col md:flex-row gap-3 items-center justify-between pb-1 border-b-[3px] border-legal-dark-blue mb-3'>
      <h2 className='flex-1 italic font-semibold capitalize text-3xl md:text-4xl text-legal-dark-blue text-center md:text-left'>
        {headerText}
      </h2>

      {additionalComponent}
    </div>
  );
};

export default PageHeader;
